import Scene from './Scene';
import Game from '../Game';
import RenderSystem from '../System/Render/RenderSystem';
import AnimationSystem from '../System/Animation/AnimationSystem';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { DRAGONBONES_PATH } from 'Constants/Dragonbones';
import PlinkoTransitionSystem from 'System/PlinkoTransitionSystem';
import AudioSystem from 'System/Audio/AudioSystem';
import BaseUISystem from 'System/UI/BaseUISystem';
import DataConflictsMenuHandler from 'System/UI/Menu/DataConflictsMenuHandler';
import GBCDisconnectedMenuHandler from 'System/UI/Menu/GBCDisconnectedMenuHandler';

export default class PlinkoTransitionScene extends Scene {
    public init(): void {
        this.addSystem(new PlinkoTransitionSystem(Game.store));
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));
        this.addSystem(new AudioSystem(Game.store));

        const UISystem = new BaseUISystem(Game.store);
        UISystem.handlers = [new GBCDisconnectedMenuHandler(UISystem), new DataConflictsMenuHandler(UISystem)];
        this.addSystem(UISystem);

        this.systems.forEach(system => system.init());
    }

    public async preload() {
        addDragonbonesResources('plinko_game_transition', `${DRAGONBONES_PATH}/PlinkoMinigameLoading/`);

        return Game.resource.load();
    }
}
